import { LinkedTagListCell } from "../../../components/molecules/Table/Cell";

/** @const */
const BILL_SOURCE_DOCUMENT_CELLS = [
  {
    header: "PURCHASE ORDERS",
    key: "purchase_orders",
    field: "purchase_orders",
    widthKey: "purchase orders",
    getTo: item => `/orders/purchase/${item.id}`,
  },
  {
    header: "TRANSFER ORDERS",
    key: "transfer_orders",
    field: "transfer_orders",
    widthKey: "transfer orders",
    getTo: item => `/transfer_order/${item.id}`,
  },
  {
    header: "RECEIPTS",
    key: "receipts",
    field: "receipts",
    widthKey: "receipts",
    getTo: item => `/receipts/${item.id}`,
  },
];

/**
 * Source-document cells for the bills list.
 *
 * @param {{
 *   order: Object,
 *   columnHeaderWidth: Object
 * }} props
 * @return {!Object<string, *>}
 */
export function billSourceDocumentListCells({ order, columnHeaderWidth }) {
  return Object.fromEntries(
    BILL_SOURCE_DOCUMENT_CELLS.map(({ header, key, field, widthKey, getTo }) => [
      header,
      <td key={key}>
        <LinkedTagListCell
          items={order?.[field]}
          getTo={getTo}
          width={columnHeaderWidth[widthKey] || 100}
        />
      </td>,
    ]),
  );
}
